import { formatDate, FORMAT_DATE_BACK, getPreviousDate } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { commonFiltersValue } from "@signals"
import { catalogueDetailsCurrentPeriod, catalogueDetailsEndDate } from "../../@signals"


export default function useCatalogueDetailsShowEvolution(siteID, productID) {
    const newFilters = commonFiltersValue.peek()

	const handleClickShowEvolution = (filters) => {
		catalogueDetailsEndDate.value = newFilters.endDate
		let startDate = formatDate(getPreviousDate({days: 6}, catalogueDetailsEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

		catalogueDetailsCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS

		filters.value = {}
		setTimeout(() => {
			filters.value = {
				...commonFiltersValue.peek(),
				startDate: startDate,
				endDate: catalogueDetailsEndDate.value,
				productID: productID,
				retailer: [siteID]
			}
		}, 0.1)
	}
   
	return {
		handleClickShowEvolution
	}
}